import * as React from 'react';

import { cn } from '@/lib/utils';

interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  size?: number | string;
  thickness?: number;
  color?: string;
  context?: 'default' | 'modal';
}

const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(
  (
    {
      className,
      size = 20,
      thickness = 3,
      color,
      context = 'default',
      style,
      ...props
    },
    ref
  ) => {
    const resolvedColorStyle =
      color === 'success'
        ? { color: 'var(--status-success)' }
        : color
          ? { color }
          : context === 'modal'
            ? { color: 'var(--TYPE-BODY-DARK)' }
            : {};

    const mergedStyle = {
      ...resolvedColorStyle,
      ...(style ?? {}),
    };

    return (
      <svg
        ref={ref}
        className={cn('inline-block animate-spin text-fg-primary', className)}
        style={mergedStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        role="progressbar"
        aria-label="Loading"
        {...props}
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeWidth={thickness}
          opacity="0.25"
        />
        <path
          d="M12 3a9 9 0 0 1 9 9"
          stroke="currentColor"
          strokeWidth={thickness}
          strokeLinecap="round"
        />
      </svg>
    );
  }
);

Spinner.displayName = 'Spinner';

export { Spinner };
export default Spinner;
